import { combineReducers } from 'redux';
import { IApplicationState } from 'store/state/app-state';
import { AuthReducer } from './auth-reducer';
import { GeneralReducer } from './general-reducer';

const rootReducer = combineReducers<IApplicationState>({
    UserData: AuthReducer,
    GeneralData: GeneralReducer,
});

export default rootReducer;
